<template>
  <v-card>
    <v-card-title primary-title>
      <h3 class="headline mb-0">Findings</h3>
    </v-card-title>
    <v-tabs
      v-model="tab"
      bg-color="primary"
    >
      <v-tab >區塊1</v-tab>
      <v-tab >區塊2(Findings)</v-tab>
    </v-tabs>
    <v-card-text>
      <v-tabs-items v-model="tab">
        <v-tab-item >
          <v-card flat>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6 v-for="(field, index) in section1" :key="index">
                  <v-select
                    v-if="field.type === 'select'"
                    :label="field.label"
                    :items="field.options"
                    v-model="formDetail[field.column]"
                    readonly
                  ></v-select>
                  <v-text-field
                    v-else
                    :label="field.label"
                    :value="field.value"
                    readonly
                  ></v-text-field>
                  
                </v-flex>
              </v-layout>

              <!-- 2：有條件的下拉選單 -->
              <v-layout row wrap>
                <v-flex 
                  xs12 
                  sm6 
                  v-for="(item, idx) in section2" 
                  :key="idx"
                  v-if="!item.depend || item.depend()"
                >
                  <v-text-field
                    v-if="item.type === 'input'"
                    :label="item.label"
                    v-model="formDetail[item.column]"
                    :readonly="item.readonly"
                    :type="item.dataType ? item.dataType : 'text'"
                    :maxlength="item.maxlength ? item.maxlength : undefined"
                  ></v-text-field>
                  <v-select
                    v-else
                    :label="item.label"
                    :items="item.options"
                    v-model="formDetail[item.column]"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item >
          <v-card flat>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6 v-for="(field, index) in section3" :key="index">
                  <v-select
                    v-if="field.type === 'select'"
                    :label="field.label"
                    :items="field.options"
                    v-model="formDetail[field.column]"
                    readonly
                  ></v-select>
                  <v-text-field
                    v-else
                    :label="field.label"
                    :value="field.value"
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green" @click="onSave">SAVE</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import common from '@/utils/common'
import { detailBody, 
complicationOptions, 
indicationOptions,
indication1Options,
verify1Options,
insertionLevelMap,
insertionLevelOptions,
premedication1aOptions,
premedication1bOptions,
premedication2bOptions,
colonPreparationOptions,
preparationTimeOptions,
preparationConditionOptions,
antiPlateletOptions,
antiPlatelet1Options,
} from '@/services/iShareHub'
export default {
props: {
  patient: {
    type: Object,
    required: true,
  },
  examination: {
    type: Object,
    required: true,
  },
},
computed:{
  age(){
    return common.calculageAge(this.patient.birthday)
  }
},
mounted(){
  this.formDetail = {
    ...this.detailBody,
    patient_sex: this.patient.gender+1,
    patient_name: this.patient.name,
    patient_birth: this.patient.birthday,
    chartno: this.examination.accNo,
    exam_date: this.examination.date,
    verify: '醫生A',
    verify1: '1',
    hosp_id: 'H000001',
    idno: this.patient.nationId,
    indication: this.checkIndication(this.examination.indication.length > 0 ? String(this.examination.indication[0]) : '2'),
    start_time: this.examination.insertionTime,
    end_time: this.examination.withdrawTime,
    reach_cecum_at: this.examination.proximalColonWithTime,
    insertion_level: String(this.examination.insertionLevel).padStart(2, '0'),
    premedication2a: Number(this.examination.antispasmodicHave) ? '1': '0',
    premedication2b: Number(this.examination.antispasmodicHave) ? this.examination.antispasmodicID : '',
    anti_platelet: this.examination.antiplateletID ? '1' : '0',
    anti_platelet1: this.examination.antiplateletID ? antiPlatelet1Options.find(option => option.id === this.examination.antiplateletID)?.value : '',
    complication: this.examination.complication ? ['0','2','1','3'][Number(this.examination.complication)] : '',
  }
  this.section1 = [
    { key: '1', label: '檢查醫療院所代碼', value: 'H000001', readonly: true },
    { key: '2', label: '身分證或護照號碼', value: this.formDetail.idno, readonly: true },
    { key: '3', label: '性別', value: this.formDetail.patient_sex === 1 ? '男' : '女', readonly: true,  },
    { key: '4', label: '姓名', value: this.formDetail.patient_name, readonly: true },
    { key: '5', label: '出生日期', value: this.formDetail.patient_birth, readonly: true },
    { key: '6', label: '年齡', value: this.age, readonly: true },
    { key: '8', label: '病歷號碼', value: this.patient.id },
    { key: '9', label: '大腸鏡檢日期', value: this.formDetail.exam_date ,readonly: true},
    { key: '12a', label: '時間登錄(檢查開始時間)', value: this.formDetail.start_time, readonly: true },
    { key: '12b', label: '時間登錄(檢查至盲腸時間)', value: this.formDetail.reach_cecum_at, readonly: true },
    { key: '12c', label: '時間登錄(檢查結束時間)', value: this.formDetail.end_time, readonly: true },
    { key: '13', label: '大腸鏡伸入最深位置', value: this.formDetail.insertion_level, readonly: true, type: 'select', options: insertionLevelOptions, column: 'insertion_level' },
  ]
  this.section2 = [
    { key: '7a', label: '適應症', type: 'select', column: 'indication', options: indicationOptions },
    { key: '7b', label: '適應症-其他1(可複選)', column: 'indication1', options: indication1Options, type: 'select', depend: () => this.formDetail.indication === '9' },
    { key: '7c', label: '適應症-其他2', column: 'indication2', type: 'input', depend: () => this.formDetail.indication === '9' && !this.formDetail.indication1 },
    { key: '10', label: '檢查醫師姓名', column: 'verify', type: 'input', readonly: false },
    { key: '11a', label: '檢查醫師科別', column: 'verify1', type: 'select', options: verify1Options },
    { key: '11b', label: '檢查醫師科別-其他科別', column: 'verify2', type: 'input' ,depend: () => this.formDetail.verify1 === '9' },
    { key: '14a', label: '檢查前用藥-止痙攣藥物', column: 'premedication1a', type: 'select', options: premedication1aOptions },
    { key: '14b', label: '檢查前用藥-止痙攣藥物原因', column: 'premedication1b', type: 'select', options: premedication1bOptions, depend: () => this.formDetail.premedication1a !== '1' },
    { key: '15a', label: '檢查前用藥-止痛鎮靜藥物', column: 'premedication2a', type: 'select', options: premedication1aOptions },
    { key: '15b', label: '檢查前用藥(可複選)-止痛鎮靜藥物項目', column: 'premedication2b', type: 'select', options: premedication2bOptions, depend: () => this.formDetail.premedication2a === '1' },
    /**
     * 16a	"清腸用藥 (可複選)"	ColonPreparation
    16b	清腸用藥-其他	ColonPreparation1
    17	清腸給藥時間	PreparationTime
    18	清腸程度	Condition
    19a	抗凝血藥物	Anti_platelet
    19b	"抗凝血藥物項目
    (可複選)"	Anti_platelet1
    19c	第一種抗凝血藥物停藥天數	Days1
    19d	第二種抗凝血藥物停藥天數	Days2
    19e	第三種抗凝血藥物停藥天數	Days3
    20a	"鏡檢後併發症
    (可複選)"	Complication
    20b	鏡檢後併發症-其他	Complication1
    21	檢體總數	Count
      */
    { key: '16a', label: '清腸用藥 (可複選)', column: 'colon_preparation', type: 'select', options: colonPreparationOptions },
    { key: '16b', label: '清腸用藥-其他', column: 'colon_preparation1', type: 'input', depend: () => this.formDetail.colon_preparation === '9' },
    { key: '17', label: '清腸給藥時間', column: 'preparation_time', type: 'select', options: preparationTimeOptions },
    { key: '18', label: '清腸程度', column: 'preparation_condition', type: 'select', options: preparationConditionOptions },
    { key: '19a', label: '抗凝血藥物', column: 'anti_platelet', type: 'select', options: antiPlateletOptions },
    { key: '19b', label: '抗凝血藥物項目 (可複選)', column: 'anti_platelet1', type: 'select', options: antiPlatelet1Options },
    { key: '19c', label: '第一種抗凝血藥物停藥天數', column: 'days1', depend: ()=>{return this.formDetail.anti_platelet !== '0'},dataType: 'number', maxlength: 2 },
    { key: '19d', label: '第二種抗凝血藥物停藥天數', column: 'days2', depend: ()=>{return this.formDetail.anti_platelet !== '0'},dataType: 'number', maxlength: 2 },
    { key: '19e', label: '第三種抗凝血藥物停藥天數', column: 'days3', depend: ()=>{return this.formDetail.anti_platelet !== '0'},dataType: 'number', maxlength: 2 },
    { key: '20a', label: '鏡檢後併發症 (可複選)', column: 'complication', type: 'select', options: complicationOptions },
    { key: '20b', label: '鏡檢後併發症-其他', column: 'complication1', type: 'input', depend: () => this.formDetail.complication === '9' },
    { key: '21', label: '檢體總數', column: 'count', type: 'input', dataType: 'number' },
  ]
  this.section3 = [
    { key: '22a', label: '前次檢查(小時)與前期療程', options: ['A', 'B', 'C'] },
    { key: '22b', label: '部位：位置', options: ['位置1', '位置2'] },
    { key: '22c', label: '位置標示(與肛門口距離)', options: ['距離1', '距離2'] },
    { key: '22q', label: '共通檢查結果', options: ['結果A', '結果B'] },
    { key: '22s', label: '未檢查原因', options: ['原因1', '原因2'] },
    // ... 更多選項
  ]
}, 
data() {
  return {
    reportCategory: 'summary',
    tab: 0,
    tabBlock2: 0,
    formDetail: {
      // ...detailBody,
      // patient_name: this.patient.name,
      // patient_birth: this.patient.birthday,
      // patient_sex: this.patient.gender,
      // patient_age: this.age,
      // chartno: this.examination.accNo,
      // exam_date: this.examination.date,
      // verify: '醫生A',
      // verify1: '1',
      // hosp_id: 'H000001',
      // idno: this.patient.nationId,
      // indication: this.examination.indication.length > 0 ? this.examination.indication[0] : '2',
    },
    // 靜態不可調整區塊
    section1: [],
    // 非Finding 可調整區塊
    section2: [],
    // Finding 可調整區塊
    section3: []
  }
},
methods: {
  onSave() {
    // 可送出表單或 emit event
  },
  checkIndication(value) {
    if (value !== '2' && value !=='1') {
      return '9'
    }
    return value
  }
},
};
</script>
